import { Box, Typography, useTheme } from "@mui/material";
import coverImage from "../../../media/images/headCover.svg";
import AuthFooter from "../../layout/AuthLayout/Footer";
import MobileHeader from "../../layout/AuthLayout/MobileHeader";
import ArrowTickLeft from "../../../media/images/icons/arrow-tick-left";
import LogoKarenSVG from "../../../media/images/icons/logo-karen";
import logoimage from "../../../media/images/logo-image-v2.0.0.png";
import parvane from "../../../media/images/parvane.png";
import mojavez from "../../../media/images/mojavez.png";
import { useNavigate } from "react-router-dom";

export default function AboutUs() {
  const theme = useTheme();
  const navigate = useNavigate();
  return (
    <>
      <MobileHeader>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography
            onClick={() => navigate("/")}
            sx={{
              cursor: "pointer",
              color: "secondary.main",
              fontWeight: 700,
              fontSize: "16px",
            }}
          >
            کارن ترابر نت
          </Typography>
          <ArrowTickLeft color={theme.palette.textColor.main} size={14} />
          <Typography
            sx={{
              color: "secondary.main",
              fontSize: "14px",
              fontWeight: 700,
            }}
          >
            درباره ما
          </Typography>
        </Box>
      </MobileHeader>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          paddingX: "8px",
          gap: "12px",
        }}
      >
        <Box
          sx={{
            backgroundImage: `
          linear-gradient(0deg, rgba(211, 134, 39, 0.97) 46.43%, rgba(239, 183, 114, 0.81) 135.27%),
            url(${coverImage})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            borderRadius: "20px",
            alignItems: "center",
            justifyContent: "center",
            paddingX: "16px",
            boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.20)",
          }}
        >
          <Typography
            sx={{
              marginTop: "32px",
              fontSize: "24px",
              fontWeight: "700",
              color: "#fff",
            }}
          >
            درباره بازارگاه کارن ترابر نت{" "}
          </Typography>
          <Typography
            sx={{
              marginBottom: "32px",
              color: "#fff",
              fontSize: "14px",
              fontWeight: "700",
            }}
          >
            تاریخچه ، اهداف، افتخارات و اعضا{" "}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "4px",
          }}
        >
          {/* <img width={120} src={logoimage} alt="" /> */}

          <Typography
            sx={{
              fontSize: "28px",
              fontWeight: "800",
              color: theme.palette.secondary[600],
            }}
          >
            درباره ما
          </Typography>
        </Box>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <Typography
            sx={{
              color: theme.palette.secondary[600],
              marginTop: "18px",
              fontWeight: "700",
              textAlign: "right",
              fontSize: "22px",
            }}
          >
            کارن ترابر نت؛
            <br /> بازارگاه حمل‌ونقل هوشمند ایران
          </Typography>
          <Typography
            sx={{
              color: "textColor.main",
              fontWeight: 600,
              fontSize: "14px",
              textAlign: "justify",
            }}
          >
            کارن ترابر نت یک بازارگاه حمل‌ونقل آنلاین است که با هدف ایجاد
            شفافیت، سرعت و امنیت در فرآیند جابه‌جایی کالا راه‌اندازی شده است.
            این سامانه به صاحبان بار، رانندگان و شرکت‌های حمل‌ونقل کمک می‌کند تا
            بدون واسطه و در کوتاه‌ترین زمان به یکدیگر متصل شوند. بازارگاه
            حمل‌ونقل کارن ترابر نت با استفاده از فناوری‌های نوین، روش‌های سنتی
            حمل بار را متحول کرده و بستری مطمئن برای ثبت سفارش بار، انتخاب
            راننده، صدور بارنامه آنلاین و پیگیری بار در لحظه فراهم کرده است. اگر
            به‌دنبال یک سامانه حمل‌ونقل اینترنتی مطمئن هستید که بتوانید در آن
            به‌سادگی بار ثبت کنید، راننده مطمئن پیدا کنید و بارنامه آنلاین
            دریافت نمایید، کارن ترابر نت بهترین انتخاب شماست.
          </Typography>
        </Box>
        <Typography
          sx={{
            color: "textColor.main",
          }}
        >
          این بازارگاه حمل‌ونقل، آینده‌ای هوشمند، شفاف و سریع را برای صنعت
          حمل‌ونقل ایران رقم می‌زند.
        </Typography>
        <Typography
          sx={{
            color: "textColor.main",
            fontSize: "18px",
            fontWeight: "700",
          }}
        >
          چرا کارن ترابر نت بهترین انتخاب است؟
        </Typography>
        <Box>
          <Typography
            sx={{
              color: theme.palette.secondary[600],
              fontSize: "18px",
              fontWeight: "700",
            }}
          >
            مزایا برای صاحبان بار
          </Typography>
          <Typography
            sx={{
              color: "textColor.main",
              fontSize: "14px",
              fontWeight: "600",
              textAlign: "justify",
            }}
          >
            یافتن سریع کامیون و راننده مناسب در هر مسیر
          </Typography>
          <Typography
            sx={{
              color: "textColor.main",
              fontSize: "14px",
              fontWeight: "600",
              textAlign: "justify",
            }}
          >
            شفافیت قیمت‌ها و امکان مقایسه هزینه‌ها پیش از انتخاب
          </Typography>
          <Typography
            sx={{
              color: "textColor.main",
              fontSize: "14px",
              fontWeight: "600",
              textAlign: "justify",
            }}
          >
            پیگیری آنلاین وضعیت بار از مبدا تا مقصد
          </Typography>
          <Typography
            sx={{
              color: "textColor.main",
              fontSize: "14px",
              fontWeight: "600",
              textAlign: "justify",
            }}
          >
            انتخاب رانندگان معتبر با بررسی سوابق و امتیاز کاربران
          </Typography>
        </Box>
        <Box>
          <Typography
            sx={{
              color: theme.palette.secondary[600],
              fontSize: "18px",
              fontWeight: "700",
            }}
          >
            مزایا برای رانندگان و شرکت‌های حمل‌ونقل
          </Typography>

          <Typography
            sx={{
              color: "textColor.main",
              fontSize: "14px",
              fontWeight: "600",
              textAlign: "justify",
            }}
          >
            دسترسی فوری به بارهای موجود بدون نیاز به حضور در پایانه‌ها
          </Typography>
          <Typography
            sx={{
              color: "textColor.main",
              fontSize: "14px",
              fontWeight: "600",
              textAlign: "justify",
            }}
          >
            کاهش هزینه‌های خالی‌کشی با معرفی بارهای برگشتی
          </Typography>
          <Typography
            sx={{
              color: "textColor.main",
              fontSize: "14px",
              fontWeight: "600",
              textAlign: "justify",
            }}
          >
            صدور بارنامه الکترونیکی به‌صورت آنلاین و بدون کاغذبازی
          </Typography>
          <Typography
            sx={{
              color: "textColor.main",
              fontSize: "14px",
              fontWeight: "600",
              textAlign: "justify",
            }}
          >
            افزایش درآمد با جذب مشتریان جدید و دسترسی گسترده‌تر به صاحبان بار
          </Typography>
        </Box>
        <Typography
          sx={{
            color: "textColor.main",
            fontSize: "18px",
            fontWeight: "700",
          }}
        >
          کارن ترابر نت؛ گام بزرگ در هوشمندسازی حمل‌ونقل
        </Typography>
        <Typography
          sx={{
            color: "textColor.main",
            fontWeight: 600,
            fontSize: "14px",
            textAlign: "justify",
          }}
        >
          کارن ترابر نت تنها یک سامانه حمل بار نیست؛ بلکه
          <strong> مدلی نوین برای مدیریت هوشمند زنجیره تأمین </strong>است. این
          بازارگاه با حذف واسطه‌ها، شفاف‌سازی هزینه‌ها و تسریع فرآیند حمل‌ونقل،
          باعث کاهش هزینه‌های اقتصادی و افزایش بهره‌وری می‌شود.
        </Typography>
        <Typography
          sx={{
            color: "textColor.main",
            fontSize: "18px",
            fontWeight: "700",
          }}
        >
          مجوزها و اعتبار قانونی
        </Typography>
        <Typography
          sx={{
            color: "textColor.main",
            fontWeight: 600,
            fontSize: "14px",
            textAlign: "justify",
          }}
        >
          بازارگاه حمل‌ونقل کارن ترابر نت دارای مجوزهای قانونی از سازمان راهداری
          و حمل‌ونقل جاده‌ای است و تمامی فرآیندها در این سامانه بر اساس قوانین
          رسمی کشور انجام می‌شود. این موضوع اعتماد صاحبان بار و رانندگان را
          تضمین کرده و امنیت معاملات را به بالاترین سطح می‌رساند.
        </Typography>
        <Box>
          <img width={"100%"} src={parvane} alt="" />
          <img width={"100%"} src={mojavez} alt="" />
        </Box>
      </Box>
      <AuthFooter />
    </>
  );
}
